import { createColor } from '~/_shared/components/colorPicker/colorPicker.helpers';
import { LabelOrMarkerVisualizerContainer } from '~/_shared/labelOrMarkerVisualizer/labelOrMarkerVisualizer.container';
import { MarkerStyleType } from '~/_shared/types/marker.types';
import { MarkerSettingType } from '~/_shared/types/markers/visualSettings.enums';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  DEFAULT_NUMERIC_BLUE_MARKER_COLOR_RGB,
  ID_OF_NUMERICAL_MARKER,
} from '~/_shared/utils/markers/markerVisualSettings.constants';
import { BubbleMarkerLabelFrameComponent } from './bubbleMarkerLabelFrame.component';

const BLUE_BUBBLE_MARKER_DIMENSION = 30;

export const BlueBubbleMarkerLabelComponent: React.FC = _ => {
  const [t] = useTranslation();

  return (
    <BubbleMarkerLabelFrameComponent title={t('Blue Bubble Markers')}>
      <LabelOrMarkerVisualizerContainer
        maxDimensions={{ height: BLUE_BUBBLE_MARKER_DIMENSION, width: BLUE_BUBBLE_MARKER_DIMENSION }}
        markerSettings={{
          useMarker: true,
          marker: {
            opacity: DEFAULT_NUMERIC_BLUE_MARKER_COLOR_RGB.a,
            selectedColor: createColor(DEFAULT_NUMERIC_BLUE_MARKER_COLOR_RGB).hex,
            size: 100,
            styleId: ID_OF_NUMERICAL_MARKER,
            styleType: MarkerStyleType.STANDARD,
          },
        }}
        visualSettingsType={MarkerSettingType.Marker}
      />
    </BubbleMarkerLabelFrameComponent>
  );
};
